interface Topic {
  label: string;
  hot: string;
}

const topics: Topic[] = [
  { label: '#暗夜追踪大结局', hot: '128万' },
  { label: '#长安风云录第三季', hot: '96万' },
  { label: '#暑期档必看', hot: '85万' },
  { label: '#星际迷航新纪元', hot: '73万' },
  { label: '#悬疑剧推荐', hot: '68万' },
  { label: '#国产剧崛起', hot: '62万' },
  { label: '#高分文艺片', hot: '55万' },
  { label: '#动作片合集', hot: '48万' },
  { label: '#韩剧热播', hot: '43万' },
  { label: '#科幻迷必看', hot: '39万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1000px] mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题</h2>
            <p className="text-sm text-foreground-600 mt-1">大家都在讨论的影视话题</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((t, i) => (
              <a
                key={i}
                href="#topics"
                className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/60 cursor-pointer transition-all hover:border-primary-500/30 hover:bg-background-200"
              >
                <span className="text-sm text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                  {t.label}
                </span>
                <span className="text-[10px] text-accent-500 font-medium whitespace-nowrap">{t.hot}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}